/** Injection key for Shell contracts (Vue provide/inject). */
export const SHELL_CONTRACTS_KEY = Symbol("SHELL_CONTRACTS_KEY");
